import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// Logistics Orders tab — GET /api/userOrder/admin.
//
// The SAME endpoint the pharmacist Orders screen and the finance Orders tab already read.
// Third consumer, still one query (the directive that governed both earlier consoles:
// extend what exists, never add a parallel query for the same rows).
//
// Every column this tab needs is already on the row:
//   - mapUserPatient         Patient / User (name, contact_no), attached post-query
//   - address                line, landmark, district, state, pincode
//   - finance                invoiceAmount, amountPaid, isCod, codStatus (includeFinance)
//   - additionalDetails      carries `extraItems`
//   - notes                  userOrders.notes (TEXT)
//
// No logistics-specific backend change was needed for this tab.
export default function useLogisticsOrders({ page = 1, size = 50, search = "", statuses = [], enabled = true } = {}) {
    const trimmed = (search || "").trim();
    const params = {
        page,
        size,
        // Adds `row.finance` (invoice amount, amount paid, COD) — the Sales Console's
        // rollup. One extra batched query per page.
        includeFinance: true,
        ...(trimmed ? { patientName: trimmed, userName: trimmed } : {}),
        // Raw statuses from the selected status chips, comma-joined; omitted = every status.
        ...(statuses.length ? { status: statuses.join(",") } : {}),
    };

    return useQuery(
        ["logistics-orders", params],
        async () => {
            const result = await request({ url: "userOrder/admin", method: "GET", params });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;

            const { count, rows } = body.data || {};
            return {
                orders: rows || [],
                pagination: { page, size, total: Number(count) || 0 },
            };
        },
        { keepPreviousData: true, retry: false, enabled }
    );
}
